import { render, staticRenderFns } from "./min-volume-cell.vue?vue&type=template&id=137a8000&"
import script from "./min-volume-cell.vue?vue&type=script&lang=ts&"
export * from "./min-volume-cell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports